import React from 'react'
import PropTypes from 'prop-types'
import UserInfo from './UserInfo'
import Persistence from './Persistence'

const UserInfos = ({userName, email, onRename, onResetEmail,
    onResetPassword, onPersistenceSet, account, onAccount, onLogout}) => {
  return (
    <div className='mt-2'>
      <UserInfo label='Jméno' value={userName} onClick={onRename}/>
      <UserInfo label='Email' value={email} onClick={onResetEmail}/>
      <UserInfo label='Heslo' value='' onClick={onResetPassword}/>
      <UserInfo label='Typ účtu' account={account} onClick={onAccount}/>
      <Persistence label='Odhlásit při zavření okna prohlížeče'
        onClick={onPersistenceSet} />
      <UserInfo label='' value='' onClick={onLogout} buttonText='Odhlásit' />
    </div>
  )
}

UserInfos.propTypes = {
  userName: PropTypes.string,
  email: PropTypes.string,
  account: PropTypes.object,
  persistence: PropTypes.bool,
  onRename: PropTypes.func,
  onResetEmail: PropTypes.func,
  onResetPassword: PropTypes.func,
  onAccount: PropTypes.func,
  onPersistenceSet: PropTypes.func
}

export default UserInfos



// WEBPACK FOOTER //
// ./src/components/User/UserInfos.js